import type { Rag } from '@/features/relatorio/types'

/**
 * Bandas RAG da Camada B, iguais às do comercial: verde ≥ 100% da meta, amarelo
 * ≥ 80%, vermelho abaixo. Existe como função ÚNICA porque a mesma decisão estava
 * escrita em três lugares com escalas diferentes — dois indicadores lado a lado
 * ficavam amarelos por critérios distintos.
 *
 * `null` (sem denominador) é `sem-meta`, não vermelho: indicador indefinido não
 * é indicador ruim.
 */
/**
 * Tolerância de ponto flutuante nas bordas: 0,72 é exatamente 80% de 0,9, mas
 * `0.72 / 0.9` dá 0,7999999999999999 e jogaria o indicador para vermelho por
 * um erro de representação, não por desempenho.
 */
const EPSILON = 1e-9

export function farol(taxa: number | null, meta: number): Rag {
  if (taxa === null) return 'sem-meta'
  const atingimento = taxa / meta
  if (atingimento >= 1 - EPSILON) return 'verde'
  if (atingimento >= 0.8 - EPSILON) return 'amarelo'
  return 'vermelho'
}
